exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.borderRounded[data-v-cf8cdf9e] {\n  border-radius:10px;\n}\n.separator[data-v-cf8cdf9e] {\n  border-bottom: 1px solid silver;\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n.spacer[data-v-cf8cdf9e] {\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cf8cdf9e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/statistics/StatisticsPage.vue
// module id = 1653
// module chunks = 2